<template>
  <div class="general-frame">
    <div class="general-neick" style="position: relative">
      <!--1.搜索框按钮-->
      <div class="general-search-bar">
        <el-select v-model="toiletId" @change="toiletChange()" placeholder="请选择" style="margin-right:15px">
          <el-option
            v-for="item in this.tableData"
            :key="item.toilet_id"
            :label="item.name"
            :value="item.toilet_id"
            >
          </el-option>
        </el-select>

        <el-button
          v-for="(item, index) in dateQuery"
          :key="index"
          @click="timeSelection(index)"
        >
          {{ item.name }}
        </el-button>

        <!-- <div class="block"> -->
        <el-date-picker
          v-show="butonStart === 0"
          v-model="timeQuery.a"
          style="margin-left: 20px"
          type="week"
          format="yyyy 第 WW 周"
          :picker-options="pickerOptions"
          @change="trigger()"
          placeholder="选择周"
        >
        </el-date-picker>

        <el-date-picker
          v-show="butonStart === 1"
          v-model="timeQuery.b"
          style="margin-left: 20px"
          type="month"
          :picker-options="pickerOptions"
          @change="trigger()"
          placeholder="选择月"
        >
        </el-date-picker>

        <el-date-picker
          v-show="butonStart === 2"
          v-model="timeQuery.c"
          style="margin-left: 20px"
          type="year"
          :picker-options="pickerOptions"
          @change="trigger()"
          placeholder="选择年"
        >
        </el-date-picker>
        <!-- <button @click="csdemo()">anniu</button> -->
        <!-- <el-button
          style="margin-left: 10px;"
          type="primary"
          class="elm-but"
          :loading="loading"
          @click="eliminate"
        >重置
        </el-button> -->
      </div>
      <!--2.echarts及table图表-->
      <div style="margin: auto">
        <!--echarts图表-->
        <div class="k_b1 flex-bottom chartsBoxWk" v-if="butonStart === 0">
          <week-Paper
            :takePaper="moto"
            :timePicker="timeQuery.a"
            ref="weekPapers"
          ></week-Paper>
        </div>

        <div class="k_b1 flex-bottom chartsBoxMh" v-if="butonStart === 1">
          <month-Paper
            :takePaper="moto"
            :timePicker="timeQuery.b"
            ref="monthPapers"
          ></month-Paper>
        </div>

        <div class="k_b1 flex-bottom chartsBoxYr" v-if="butonStart === 2">
          <year-Paper
            :takePaper="moto"
            :timePicker="timeQuery.c"
            ref="yearPapers"
          ></year-Paper>
        </div>

        <!--table表格-->
        <div style="padding: 20px">
          <!--table表格 start-->
          <el-table
            :data="tableData"
            style="width: 100%"
            :cell-style="{ textAlign: 'center' }"
            :header-cell-style="{
              background: '#f7f7f7',
              color: '#0b1117',
              textAlign: 'center'
            }"
          >
            <el-table-column>
              <template slot="header">
                <i class="iconfont icon-cesuo"></i>
                <span>厕所名称</span>
              </template>
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.name
                }}</span>
              </template>
            </el-table-column>

            <el-table-column>
              <template slot="header">
                <i class="iconfont icon-ziyuanxhdpi"></i>
                <span>设备编号</span>
              </template>
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.ser_num }}</span>
              </template>
            </el-table-column>

            <el-table-column>
              <template slot="header">
                <i class="iconfont icon-jinri"></i>
                <span>今日出纸次数</span>
              </template>
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.dayOutNum + "次"
                }}</span>
              </template>
            </el-table-column>

            <el-table-column>
              <template slot="header">
                <i class="iconfont icon-benyue"></i>
                <span>本月出纸次数</span>
              </template>
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.monthOutNum + "次"
                }}</span>
              </template>
            </el-table-column>

            <el-table-column>
              <template slot="header">
                <i class="iconfont icon-benyue"></i>
                <span>本月出纸卷数</span>
              </template>
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.monthUse + "卷"
                }}</span>
              </template>
            </el-table-column>

            <el-table-column v-if="global.power('usermgr.update') == true">
              <template slot="header">
                <i class="iconfont icon-ccaozuo"></i>
                <span>操作</span>
              </template>
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="dialogPopsUp(scope.$index, scope.row)"
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!--table表格 end-->

          <!--修改出纸时间弹出层 start-->
          <el-dialog
            :visible.sync="dialogFormVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
          >
            <template slot="title" class="sd">
              <span>修改出纸时间</span>
            </template>

            <div
              v-loading="loading"
              element-loading-text="正在修改中"
              element-loading-spinner="el-icon-loading"
            >
              <el-row>
                <el-form ref="form" :model="form" :rules="formFules">
                  <el-col :span="12">
                    <div class="grid-content bg-purple">
                      <el-form-item
                        label="设备编号"
                        :label-width="formLabelWidth"
                      >
                        <el-input v-model="form.ser_num" disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="grid-content bg-purple">
                      <el-form-item
                        label="出纸时间"
                        prop="outTime"
                        required
                        :label-width="formLabelWidth"
                      >
                        <el-input
                          v-model="form.outTime"
                          maxlength="4"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-form>
              </el-row>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updata('form')"
                  >确 定</el-button
                >
              </div>
            </div>
          </el-dialog>
          <!--修改出纸时间弹出层 end-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import noData from "@/components/html/noData";
import weekPaper from "@/components/html/paperWeekEcharts.vue";
import monthPaper from "@/components/html/paperMonthEcharts.vue";
import yearPaper from "@/components/html/paperYearEcharts.vue";
import dayjs from "dayjs";
import { EchatsMixin } from "@/utils/echarts";

export default {
  components: {
    noData,
    weekPaper,
    monthPaper,
    yearPaper
  },
  mixins: [EchatsMixin],
  data() {
    return {
      message: true,
      value1: "",
      startDate: null,
      endDate: null,
      formFules: {
        outTime: [
          {
            validator: function(rule, value, callback) {
              if (/^[0-9]*$/.test(value) == false && value != "") {
                callback(new Error("只能输入数字！"));
              } else if (/^\d{4,}$/.test(value) == false && value != "") {
                callback(new Error("请输入至少4位数字！"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      },
      toiletDataList: [],
      dateQuery: [
        // {name: "日"},
        { name: "周" },
        { name: "月" },
        { name: "年" }
      ],
      timeQuery: {
        a: new Date(),
        b: new Date(),
        c: new Date()
      },
      dasdasd: "",
      pageSize: 10, //每页10条
      pageNum: 1, //当前页码
      total: 0,
      data: null,
      startTime: null,
      butonStart: 0,
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如
        }
      },
      tableData: [],
      dialogFormVisible: false,
      form: {
        ser_num: "",
        outTime: ""
      },
      formLabelWidth: "120px",
      moto: [],
      start_Time: this.$route.query.startDate,
      end_Time: this.$route.query.endDate,
      wisDomToilet: "300009",
      toiletId: 12
    };
  },
  methods: {
    getList() {
      this.get("toiletInfo/list", {
        beginTime: this.beginTime,
        endTime: this.endTime,
        isQueryAll: false
      }).then(res => {
        this.data = res.data.rows;
        this.total = res.data.total;
      });
    },

    // 出纸机统计table表格数据api查询操作
    getTotilPerpo() {
      this.get("/outPaper/getList", {}).then(res => {
        this.tableData = res.data.data;
        this.tableData.map(e => {
          if (e.toilet_id === this.toiletId) {
            this.wisDomToilet = e.ser_num;
          }
        })
        this.getRecordCount(this.butonStart);
      });
    },

    toiletChange() {
      this.tableData.map(e => {
          if (e.toilet_id === this.toiletId) {
            this.wisDomToilet = e.ser_num;
          }
        })
      this.timeSelection(this.butonStart)
      this.getRecordCount(this.butonStart);
    },

    /*
    调用接口获取选择周的参数
    参数
    tableNum:number 判断调用什么类型图形
    */
    getRecordCount(tableNum) {
      if (!tableNum && tableNum != 0) return;
      //1.初始传参——即用点击过来获取的当前周的时间
      this.get("/outPaper/recordCount", {
        sbh: this.wisDomToilet,
        beginTime: this.start_Time,
        endTime: this.end_Time
      }).then(res => {
        this.moto = res.data.data;
        // this.drawLineDemo(this.moto);
        if (tableNum == 0) {
          this.$refs.weekPapers.weekPaper();
        } else if (tableNum == 1) {
          this.timeQuery.b = this.start_Time.substring(
            0,
            this.start_Time.length - 3
          );
          this.$refs.monthPapers.monthPaper();
        } else {
          this.timeQuery.c = this.start_Time.substring(
            0,
            this.start_Time.length - 3
          );
          this.$refs.yearPapers.yearPaper();
        }
      });
      // }
    },

    getWeek(dateString) {
      let dateArray = dateString.split("-");
      let date = new Date(
        dateArray[0],
        parseInt(dateArray[1] - 1),
        dateArray[2]
      );
      return "周" + "日一二三四五六".charAt(date.getDay());
    },

    //出纸机时间编辑设置弹窗dialog
    dialogPopsUp(index, val) {
      this.dialogFormVisible = true;
      this.form.ser_num = val.ser_num;
      this.form.outTime = val.outTime;
      // this.updata(index,this.toileform.ser_num,this.toileform.outTime)
    },

    //出纸机时间修改api
    updata(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.loading = true;
          this.post("/outPaper/update", {
            ser_num: this.form.ser_num,
            work_fre: this.form.outTime
          }).then(res => {
            if (res.data.code == 200) {
              this.loading = false;
              this.$message({
                type: "success",
                message: "修改成功!"
              });
              this.dialogFormVisible = false;
            }
          });
        }
      });
    },

    loadDialog() {
      this.loading = this.$loading({
        lock: true, //lock的修改符--默认是false
        text: "Loading", //显示在加载图标下方的加载文案
        target: document.querySelector("#el-dialog") //loadin覆盖的dom元素节点
      });
    },

    //厕所人流
    getToiletPeople() {
      this.get("toiletData/listCount", {
        beginTime: this.beginTime,
        endTime: this.endTime
      }).then(res => {
        this.toiletDataList = res.data.rows;
      });
    },

    //时序选择——改变下方图表
    timeSelection(index) {
      if (index == 0) {
        this.start_Time = dayjs().startOf("week").format("YYYY-MM-DD");
        this.end_Time = dayjs().endOf("week").format("YYYY-MM-DD");
      } else if (index == 1) {
        this.start_Time = dayjs().startOf("month").format("YYYY-MM-DD");
        this.end_Time = dayjs().endOf("month").format("YYYY-MM-DD");
      } else if (index == 2) {
        this.start_Time = dayjs().startOf("year").format("YYYY-MM-DD");
        this.end_Time = dayjs().endOf("year").format("YYYY-MM-DD");
      }
      this.butonStart = index;
      this.getRecordCount(this.butonStart);
    },

    //选择时间-对echarts的图表数据进行查询
    trigger() {
      let num = "";
      if (this.butonStart == 0) {
        this.start_Time = dayjs(this.timeQuery.a)
          .startOf("week")
          .format("YYYY-MM-DD");
        this.end_Time = dayjs(this.timeQuery.a)
          .endOf("week")
          .format("YYYY-MM-DD");
        num = 0;
      } else if (this.butonStart == 1) {
        this.start_Time = dayjs(this.timeQuery.b)
          .startOf("month")
          .format("YYYY-MM-DD");
        this.end_Time = dayjs(this.timeQuery.b)
          .endOf("month")
          .format("YYYY-MM-DD");
        num = 1;
      } else if (this.butonStart == 2) {
        this.start_Time = dayjs(this.timeQuery.c)
          .startOf("year")
          .format("YYYY-MM-DD");
        this.end_Time = dayjs(this.timeQuery.c)
          .endOf("year")
          .format("YYYY-MM-DD");
        num = 2;
      }
      this.getRecordCount(num);
    },

    //重置
    eliminate() {
      this.timeQuery = {};
      this.beginTime = null;
      this.endTime = null;
      this.getList();
      this.getToiletPeople();
    },

    //pageNum  改变时会触发
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList(); //调用终端数据接口
    },

    //pageSize改变时会触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
    }
  },
  mounted() {
    this.toiletId =
        this.$route.query.equipmentId == null ? 12 : parseInt(this.$route.query.equipmentId);
    this.getList();
    this.getToiletPeople();
    this.getTotilPerpo();
    this.timeSelection(0);
  },
  beforeCreate() {}
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  border-bottom: 1px solid #e8e8e8;
}

/deep/.el-dialog__body {
  border-bottom: 1px solid #e8e8e8;
}
/deep/.dialog-footer {
  text-align: center;
  padding: 10px 20px 5px;
}
/deep/ .el-input--suffix .el-input__inner {
  width: 240px !important;
}

.general-search-bar {
  margin: 6px 0 6px 0;
  line-height: 64px;
  padding-left: 20px;
  border-bottom: 1px solid #dcdfe6;
}

.chartsBoxWk {
  margin: 0;
  height: 415px;
}
.chartsBoxMh {
  margin: 0;
  height: 300px;
}
.chartsBoxYr {
  margin: 0;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/pages/menu/toilet/toileUseThePaper.vue